import {TYPES} from './improvement-action-type.constants';
import {IDS} from './improvement-action-id.constants';
import * as TABS from '../../../common/tabs/tabs.constants';
import {TabsReducer} from '../../../common/tabs/tabs.reducer';
import * as FORM from '../../../common/form/input/input.constants';
import {GridReducer} from '../../../common/grid/grid.reducer';
import {GridFilterReducer} from '../../../common/grid/filter/grid-filter.reducer';
import {getAvailableYearsRange} from '../../../reducers/accreditation.reducer';
import * as GRID from '../../../common/grid/grid.constants';
import get from 'lodash/get';
import set from 'lodash/set';
import merge from 'lodash/merge';
import pick from 'lodash/pick';
import moment from 'moment'
import {INPUT_TEXT} from "../../../common/form/input/input.constants";
import {getDocFileNameFromPath} from "../../../common/utils/util.path";

/**
 * @function DocumentReducer
 * @param state {object}
 * @param action {object}
 * @returns {object} Redux Store
 * @memberOf Reducers
 */
export function ImprovementReducer(state, action) {

    if (typeof state === 'undefined') {
        const currentYear = parseInt(moment().format('YYYY'))
        return {
            availableYears: getAvailableYearsRange(currentYear),
            // reviewStatuses: [],
            [IDS.assigneeCandidates]: [],
            [IDS.improvementAction]:{},
            [IDS.improvementStepsGrid]:  {...GridReducer(),
                filter: {
                    ...GridFilterReducer(),
                    limit: 100,
                    path: IDS.improvementStepsGrid,
                }},
            [IDS.rcoEvidenceGroupDocumentsGrid]: {...GridReducer(),
                filter: { limit: null },
            },
            [IDS.improvementStep]: {},
            [IDS.step]: {},
            [IDS.stepDocument]: {},
            [IDS.stepAssigneeCandidates]: [],
            [IDS.stepStatusOptions]: [],
            [IDS.stepStatusOptionsForAssigned]: [
                { value: 'pen', label: 'Assigned' },
                { value: 'cpl', label: 'Completed And Approved' },
            ],
            [IDS.stepStatusOptionsForSubmitted]: [
                { value: 'pen', label: 'Rejected' },
                { value: 'sub', label: 'Submitted For Approval' },
                { value: 'cpl', label: 'Approved' },
            ],
            [IDS.stepStatusOptionsForApproved]: [
                // { value: 'pen', label: 'Rejected' },
                { value: 'cpl', label: 'Completed And Approved' },
            ],
            [IDS.improvementActionsGrid]: GridReducer(),

            level1Requirements: [],
            level2Requirements: [],
            level3Requirements: [],
            level1RequirementId: null,
            level2RequirementId: null,
            level3RequirementId: null,
            linkableEvidenceGroups: [],
            evidenceGroupId: null,
        }
    }

    switch (action.type) {
        case TYPES.FETCH_SITE_LOCATION_DETAILS:
            if (action.id === IDS.rcoImprovement) {
                return { ...state, ...action.data }
            }
        case TYPES.FETCH_ASSIGNEE_CANDIDATES:
            return set({...state}, action.path || IDS.assigneeCandidates, action.data)

        case TYPES.SET_ACTION_DETAILS:
            if (action.id === IDS.rcoImprovement) {
                const assignee = {
                    name: action.details.assignee,
                    subject_uuid: action.details.assignee_uuid,
                }
                state = set({...state}, IDS.assigneeCandidates, [assignee]);
                return set(state, IDS.improvementAction, {
                    ...action.details,
                    assignee,
                    requirements: JSON.parse(action.details?.requirements || '[]'),
                    title: action.details?.name,

                });
            }
        case TYPES.SET_IMPROVEMENT_ACTION_DETAILS:
            return set({...state}, IDS.improvementAction, action.details);
        case TYPES.SET_IMPROVEMENT_STEP_DETAILS:
            return set({...state}, IDS.improvementStep, action.details);
        case TYPES.UPDATE_IMPROVEMENT_STEP:
            // insert dialog object in to grid items
            // state = set({...state},
            //     `${IDS.improvementStepsGrid}.items[${state.step.id}]`,
            //     get(state, IDS.improvementStep));
            // refresh grid
            return set({...state}, IDS.improvementStepsGrid,
                GridReducer( get(state, IDS.improvementStepsGrid), {
                    type: GRID.GRID_FETCH,
                    items: get(state, `${IDS.improvementStepsGrid}.items`, []),
                })
            );
        case TYPES.RESET_NEW_STEP_DETAILS:
            return set({...state}, IDS.improvementStep, {});
        case TYPES.RESET_REQUIREMENT:
            return set({...state}, 'level3RequirementId', null);
        case TYPES.SELECT_STEP:
            if(action.id === IDS.rcoImprovement) {
                state = {...state};
                if (action.details && Object.keys(action.details).length > 0) {
                    const statusCode = action.details.status_code;
                    const assignee = {
                        name: action.details.assignee,
                        subject_uuid: action.details.assignee_uuid,
                    };
                    set(state, IDS.stepAssigneeCandidates, [assignee]);
                    set(state, IDS.stepStatusOptions,
                        statusCode === 'pen' ? get(state, IDS.stepStatusOptionsForAssigned)  :
                        statusCode === 'sub' ? get(state, IDS.stepStatusOptionsForSubmitted) :
                        statusCode === 'cpl' ? get(state, IDS.stepStatusOptionsForApproved)  :
                    []);
                    const doc_type = get(state, `${IDS.stepDocument}.doc_type`);
                    set(state, `${IDS.stepDocument}.doc_type`, doc_type || action.firstDocType);
                    return set(state, IDS.step, {
                        assignee,
                        task_id:            action.details.uta_id,
                        task_number:        action.details.task_number,
                        title:              action.details.name,
                        created_by:         action.details.created_by,
                        created_at:         action.details.created_at,
                        description:        action.details.description,
                        requirement_id:     action.details.requirement_id,
                        requirement_name:   action.details.requirement_name,
                        evidence_id:        action.details.ard_id,
                        evidence_name:      action.details.evidence_name,
                        closing_comment:    action.details.closing_comment,
                        closing_author:     action.details.closing_author,
                        closing_date:       action.details.closing_date,
                        rejection_author:   action.details.rejection_author,
                        rejection_comment:  action.details.rejection_comment,
                        rejection_date:     action.details.rejection_date,
                        due_date:           action.details.due_date,
                        status_code:        statusCode,
                        original_status_code:statusCode,
                    });
                } else
                    return set(state, IDS.step, {});
            }
            else return state;
        case TYPES.SELECT_NEW_STEP_REQUIREMENT:
            if (action.id === IDS.rcoImprovement) {
                state = {...state};
                if(action.level < 3){
                    state = set(state,
                        `level${action.level + 1}Requirements`,
                        action.requirements.map(item => ({
                            value: item.id,
                            label: item.name,
                            disabled: item.disabled,
                        }))
                    )
                    set(state, 'level3RequirementId', null)
                }
                let name = '';
                let requirementParentId = null;
                // let activities = []; // all requirement ids for which evidence task will be created
                switch(action.level){
                    case 1:
                        const firstChild = get(action.requirements,'[0]');
                        set(state, `level3RequirementName`, null);
                        requirementParentId = action.requirementId;
                        set(state, 'level2RequirementId', firstChild.id);
                        set(state, 'level3Requirements',
                            firstChild.children.map(item => ({
                                value: item.id,
                                label: item.name,
                            }))
                        );
                        set({...state}, 'linkableEvidenceGroups',[]);
                        break;
                    case 2:
                        set(state, `level3RequirementName`, null);
                        set(state, 'level2RequirementId', action.requirementParentId);
                        set(state, 'level3Requirements',
                            action.requirements.map(item => ({
                                value: item.id,
                                label: item.name,
                            }))
                        );
                        set({...state}, 'linkableEvidenceGroups',[]);
                        break;
                    case 3:
                        set(state, 'level3RequirementId', action.requirementId);
                        set(state, `level3RequirementName`, action.name);
                        requirementParentId = action.requirementParentId;
                        // reset selected evidence group
                        set(state, `evidenceGroupId`, null);
                        // refresh grid
                        set(state, IDS.improvementStepsGrid,
                            GridReducer( get(state, IDS.improvementStepsGrid), {
                                type: GRID.GRID_FETCH,
                                items: get(state, `${IDS.improvementStepsGrid}.items`, []),
                            })
                        );
                        break;
                }
                // set(state, 'details.activities', activities);
                // set(state, `${IDS.improvementStep}.requirementId`, requirementId);
                // set(state, `${IDS.improvementStep}.requirementParentId`, requirementParentId);
            }
            return state
        case TYPES.FETCH_REQUIREMENT_EVIDENCE_GROUPS:
            if(action.id === IDS.rcoImprovement) {
                return set({...state}, 'linkableEvidenceGroups',
                    action.items.map(item => ({
                        label: item.name,
                        value: item.ard_id,
                    }))
                );
            }
            else return state;
        case TYPES.RESET_SELECTED_EVIDENCE_GROUP:
            if(action.id === IDS.rcoImprovement) {
                return set({...state}, `evidenceGroupId`, null)
            }
            else return state;
        case TYPES.RESET_LINKABLE_EVIDENCE_GROUPS:
            if(action.id === IDS.rcoImprovement) {
                return set({...state}, 'linkableEvidenceGroups',[])
            }

        /* GENERIC TYPES */

        case 'LOCATION_SELECTED':
            if(action.id === IDS.rcoImprovement) { // slo select-cascade
                if(action.type_code === 'slo') {
                    const gridId = IDS.improvementActionsGrid;
                    state = set({...state}, gridId, GridReducer(state[gridId], set(action, 'type', 'PAGINATE')));
                    return set(state, `${gridId}.filter.slo_uuid`, action.uuid);
                }
                else return state;
            }
            else return state;

        case 'AUTOCOMPLETE_SELECTED':
            if (action.id === IDS.rcoImprovement && action.item) {
                return set({...state}, action.path, action.item)
            }
        case FORM.INPUT_SELECT:
        case FORM.INPUT_TEXT:
        case FORM.INPUT_CHECKBOX:
        case FORM.INPUT_DATE:
        case FORM.INPUT_RADIO:
        case 'INPUT_EMAIL_CHANGE':
        case 'INPUT_PHONE_CHANGE':
        case 'INPUT_TEXT_AREA_CHANGE':
        case 'INPUT_SIGNATURE':
            if (action.id === IDS.rcoImprovement) {
                state = {...state};
                const gridId = action.path.split('.')[0];
                if(gridId === IDS.improvementActionsGrid) {
                    const filter = {
                        [action.path.split('.').pop()]: action.input
                    };
                    return set(state, gridId,
                        GridReducer(get(state, gridId), { type: GRID.GRID_FILTER, filter })
                    )
                }
                else {
                    if (action.path === 'evidenceGroupId') {
                        set(state, 'evidenceGroupName', action.item.label);
                        set(state, 'improvementStep.title', action.item.label);
                    }
                    else if (action.path === 'step.status_code') {
                        if (action.item.value === 'pen' && state.step.original_status_code !== 'pen') {
                            set(state, 'step.newRejectionComment', null);
                        }
                    }
                    return set(state, action.path, action.input)
                }
            }
        case GRID.GRID_INIT:
        case GRID.GRID_FILTER:
        case GRID.GRID_FILTER_TOGGLE:
        case GRID.GRID_RESET_FILTER:
        case GRID.GRID_INIT_FILTER:
        case GRID.GRID_LOADING:
        case GRID.GRID_PAGINATE:
        case GRID.GRID_RELOAD:
        case GRID.GRID_FETCH:
        case GRID.GRID_SELECT:
        case GRID.GRID_SELECT_ALL:
        case GRID.GRID_DESELECT:
        case GRID.GRID_DESELECT_ALL:
            if (action.id === IDS.rcoImprovement) {
                return set({...state}, action.path,
                    GridReducer( get(state, action.path), action)
                )
            }
        case GRID.GRID_RESET:
            if (action.id === IDS.rcoImprovement) {
                return set({...state}, action.path,
                    GridReducer( get(state, action.path),{
                        type: GRID.GRID_RESET_FILTER,
                        // exclude: action.exclude || (action.path === IDS.documentAddGrid ? ['slo_uuid','excludeDocIds'] : []),
                    })
                )
            }
        default:
            return state;
    }
}

const index = (children, list = []) => {
    children && children.forEach(item => {
        if(item) {
            list[parseInt(item.id)] = item;
            index(item.children, list);
        }
    })
    return list;
};
